<template>
    <transition name="action-bounce" @after-leave="onAfterLeave">
        <div v-if="isEnable"
            class="action-result-view" :class="this.status"
        >
            <i class="align-middle me-2 fas fa-fw"
                :class="[{'fa-check':this.status == 'success'},{'fa-times-circle':this.status == 'fail'}]"
            ></i>
            <span class="align-middle">{{ massage }}</span>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'actionResult',
    data() {
        return {
            isEnable: false,
            status: '',
            massage: ''
        };
    },
    methods: {
        show(data) {
            if (this.isEnable) {
                return;
            }
            this.status = data.status ? data.status : '';
            this.massage = data.massage ? data.massage : '';
            this.isEnable = true;
            setTimeout(() => {
                // 這裡不直接設置 isEnable = false，等待動畫結束後處理
                this.isEnable = false;
            }, 3000);
        },
        onAfterLeave() {
            // this.isEnable = false;
        }
    }
};
</script>

<style scoped>
    .action-result-view {
        position: fixed;
        background-color: #ffffff;
        top: 5%;
        left: 50%;
        padding: .25rem 2rem;
        font-size: 1.25rem;
        box-shadow: 0px 0px 12px #00000038;
        border-radius: 0.115rem;
        transform: translate(-50%, -150%);
        opacity: 0;
        transition: transform 0.6s ease, opacity 0.6s ease;
    }

    .action-result-view.success {
        color: #3eb058;
    }

    .action-result-view.fail {
        color: #b03e3e;
    }

    /* 彈出動畫 */
    .action-bounce-enter-active, .action-bounce-leave-active {
        transition: transform 0.5s ease, opacity 0.5s ease;
    }

    .action-bounce-enter, .action-bounce-leave-to {
        transform: translate(-50%, -150%);
        opacity: 0;
    }

    .action-bounce-enter-to {
        transform: translate(-50%, 0%);
        opacity: 1;
    }

    .action-bounce-leave-to {
        transform: translate(-50%, -150%);
        opacity: 0;
    }
</style>
